import { render, staticRenderFns } from "./adddigi.vue?vue&type=template&id=be98fe0e&scoped=true"
import script from "./adddigi.vue?vue&type=script&lang=js"
export * from "./adddigi.vue?vue&type=script&lang=js"
import style0 from "./adddigi.vue?vue&type=style&index=0&id=be98fe0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be98fe0e",
  null
  
)

export default component.exports